import { Component, ViewChild } from "@angular/core";
import { CountryService } from "../../../domain/country-service";
import { Country } from "../../../domain/country";
import { UserRepository } from "../../../domain/user-repository";
import { NgForm } from "@angular/forms";
import { SessionStorageService } from "../../../services/session-storage.service";
import { Router } from "@angular/router";
import {
  RequestDemoData,
  TenantRepository,
} from "../../../domain/tenant-repository";

@Component({
  selector: "request-demo",
  templateUrl: "./request-demo.component.html",
  styleUrls: ["./request-demo.component.scss"],
})
export class RequestDemoComponent {
  isFormValid: boolean = true;
  formData: RequestDemoData = new RequestDemoData();
  countries: Array<Country>;
  languages: [{ code: string; name: string }];

  @ViewChild("requestDemoForm", { static: true }) form: NgForm;

  constructor(
    private countryService: CountryService,
    private userRepository: UserRepository,
    private sessionStorageService: SessionStorageService,
    private tenantRepositgory: TenantRepository,
    private router: Router,
  ) {
    this.countries = countryService.countries;
    this.languages = userRepository.getCurrentUser().languages;
  }

  onSubmitForm(form: NgForm) {
    if (form.valid) {
      //store the form data in the browser session storage
      this.sessionStorageService.setItem(
        "requestDemoTenantData",
        this.formData,
      );

      //and then redirect to choose template wizard
      this.router.navigateByUrl("/tenant/choose-template");
    } else {
      Object.keys(form.controls).forEach((field) => {
        // {1}
        const control = form.controls[field];
        console.log("control errors", control.errors);
        control.markAsTouched({ onlySelf: true }); // {3}
      });
    }
  }

  validateEmailExists(email: string) {
    if (this.form.controls["email"].valid) {
      this.userRepository
        .validateUsernameExists(email)
        .then((result: boolean) => {
          let control = this.form.controls["email"];
          if (result) {
            control.setErrors({ usernameExists: true });
          } else {
            control.setErrors(null);
          }
          control.markAsTouched({ onlySelf: true });
        });
    }
  }

  verifyField(fieldName: string, validatorName: string): boolean {
    return !(
      this.form.controls[fieldName] &&
      this.form.controls[fieldName].touched &&
      this.form.controls[fieldName].errors &&
      this.form.controls[fieldName].errors[validatorName]
    );
  }
}
